var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05648 9.78668L3.77917 8.76483C3.59832 9.28184 3.5 9.8376 3.5 10.4163C3.5 13.1777 5.73858 15.4163 8.5 15.4163C11.2614 15.4163 13.5 13.1777 13.5 10.4163C13.5 9.8376 13.4017 9.28184 13.2208 8.76483L11.9435 9.78668C11.9806 9.99093 12 10.2014 12 10.4163C12 12.3493 10.433 13.9163 8.5 13.9163C6.567 13.9163 5 12.3493 5 10.4163C5 10.2014 5.01938 9.99093 5.05648 9.78668Z",
    fill: "#0D0F18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49992 3.33331L8.0314 2.74766L8.49992 2.37284L8.96844 2.74766L8.49992 3.33331ZM9.24992 9.70831C9.24992 10.1225 8.91413 10.4583 8.49992 10.4583C8.0857 10.4583 7.74992 10.1225 7.74992 9.70831L9.24992 9.70831ZM4.48973 5.58099L8.0314 2.74766L8.96844 3.91896L5.42677 6.7523L4.48973 5.58099ZM8.96844 2.74766L12.5101 5.58099L11.5731 6.7523L8.0314 3.91896L8.96844 2.74766ZM9.24992 3.33331L9.24992 9.70831L7.74992 9.70831L7.74992 3.33331L9.24992 3.33331Z",
    fill: "#0D0F18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.779b874dabea1949d67df08826e055d4.svg";
export { ForwardRef as ReactComponent };